(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('SellerGoalsController', SellerGoalsController);
    SellerGoalsController.$inject = ['GeneralReportsService'];
    function SellerGoalsController(GeneralReportsService) {
        var vm = this;

        vm.flag                  = false;
        vm.getSemesters          = getSemesters;
        vm.semesterSelected      = -1;
        vm.getByFilter           = getByFilter;

        function activate() {
            vm.getSemesters();
        }

        function getSemesters() {
            vm.semesters = [];
            GeneralReportsService.getSellerGoalsSemesters().then(function (response) {
                angular.forEach(response.data, function(value) {
                    this.push({id : value.semester, name : value.semester });
                }, vm.semesters);
                vm.semesters.unshift({id : -1, name: '--- All ---'});
            });
        }

        
        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            vm.query['semester'] = vm.semesterSelected;
            GeneralReportsService.getSellerGoals(vm.query).then(function (response) {
                vm.flag = true;
                vm.goals = response.data;                             
                console.log(vm.sellerGoals)
            });
        }

        activate();
    }
})();